import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Curriculum.cssmodule.less';
import classNames from 'classnames';
import { clickButton } from '../../actions/Modal';
import { bindActionCreators } from 'redux';

class CurriculumAlert extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.defaultContent = {
            title: this.Utils.getLang('Menus.lecture_finish_popup_title'),
            content: <div>
                <strong className={this.Style.sjt} dangerouslySetInnerHTML={{__html:this.Utils.getLang('Menus.lecture_finish_popup_content_1')}} />
                <p className={this.Style.dsc} dangerouslySetInnerHTML={{__html:this.Utils.getLang('Menus.lecture_finish_popup_content_2')}} />
            </div>,
            buttons: [{
                trigger: 'reset',
                text: this.Utils.getLang('Buttons.lecture_finish_popup_reset_lecture'),
            }, {
                className: this.Style.active,
                trigger: 'close',
                text: this.Utils.getLang('Buttons.lecture_finish_popup_show_output'),
            }],
        };

        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'CURRICULUM_ALERT');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({ event });
    }

    createButton(buttons) {
        return buttons.map((button, i) => <span key={i} className={classNames(this.Style.btn, button.className)} onClick={() => this.handleButtonClick(button.trigger)}>{button.text}</span>);
    }

    render() {
        const { item = {} } = this.props;
        const { buttons = this.defaultContent.buttons, content = this.defaultContent.content, title=this.defaultContent.title} = item;
        return (
            <div className={this.Style.alert_pop_wrap}>
                <div className={this.Style.pop_header}>
                    <strong className={this.Style.sjt}>{title}</strong>
                </div>
                <div className={this.Style.pop_cont}>
                    {content}
                </div>
                <div className={this.Style.pop_btn_box}>
                    {this.createButton(buttons)}
                </div>
                <span className={this.Style.pop_close} onClick={() => this.handleButtonClick('close')}>close</span>
            </div>
        );
    }
}

CurriculumAlert.displayName = 'CurriculumAlert';
CurriculumAlert.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps,
)(CurriculumAlert);



// WEBPACK FOOTER //
// ./components/ModalSet/CurriculumAlert.js